import PropTypes from 'prop-types';
import React, { useCallback } /* { useEffect }  */ from 'react';

import { Expandable } from 'sharedComponents';
import AssetList from './AssetList';
import PowerTrainListItemTitle from './PowerTrainListItemTitle';


const PowertrainListItem = ({
	powertrain,
	isSelected,
	onPowertrainClick,
	onAssetClick
}) => {
	const handlePowertrainToggle = useCallback(() => {
		if (!isSelected) {
			console.log(powertrain?.powertrainId);
			console.log('the powertrain assets', powertrain?.assets);
			onPowertrainClick(powertrain?.powertrainId);
		}
		else {
			console.log('onPowertrainClick(undefined)');
			onPowertrainClick(undefined);
		}
	}, [powertrain?.powertrainId, isSelected]);


	return <Expandable
		title={<PowerTrainListItemTitle systemName={powertrain?.name} overallStatus={powertrain?.overallStatus} />}
		open={isSelected}
		onClick={handlePowertrainToggle}
	>
		{isSelected &&
			<AssetList assets={powertrain?.assets} insidePowertrain onAssetClick={onAssetClick} />
		}
	</Expandable>;
};

PowertrainListItem.propTypes = {
	powertrain: PropTypes.shape({
		components: PropTypes.any,
		overallStatus: PropTypes.any,
		systemID: PropTypes.any,
		systemName: PropTypes.any,
		assets: PropTypes.array,
		powertrainId: PropTypes.any,
		name: PropTypes.any
	}),
	selectedPowertrainID: PropTypes.any,
	onAssetClick: PropTypes.func,
	onPowertrainClick: PropTypes.func
};

export default React.memo(PowertrainListItem);
